import { TTintService } from 'features/product-info/components/pdp-select-tint-color';

type TProps = {
  servicesFromCookies: (TTintService | never)[];
  selectedColor: string;
  newQuantity: number;
  hex: string;
};

export const getServicesWithUpdatedQuantity = ({
  servicesFromCookies,
  selectedColor,
  newQuantity,
  hex,
}: TProps) => {
  return servicesFromCookies.map((service) => {
    if (service?.parameters?.color === selectedColor) {
      return {
        ...service,
        quantity: newQuantity,
        hex,
      };
    } else {
      return service;
    }
  });
};
